import style from '../portfolio-items.module.css'
import Carousel from './embla-carousel/zodiak-embla.jsx'
import Portfolio from '../../../main/portfolio.jsx'
import ContactForm from '../../../main/contactForm.jsx'
import HireUs from '../../../forIndustrial/hireUs.jsx'

const OPTIONS = {}

export default function Zodiak(props) {
    return (
        <div className={style.wrapper}>
            <div className={style.container}>
                <h1><span style={{color: '#ff8c00'}}>Монтаж комплектных трансформаторных подстанций </span><br /> на СЭС Зодиак</h1>
                <Carousel options={OPTIONS} />
                <div className={style.description}>
                    <div className={style.tasks}>
                        <h6>Задача:</h6>
                        <p>Строительство 12 комплектных трансформаторных подстанций типа 2КТП(Н) и 3 комплектных трансформаторных подстанций типа КТП(Н) для СЭС Зодиак.</p>
                    </div>
                    <div className={style.specification}>
                        <div сlassName={style.info}>
                            <p><strong>Заказчик: </strong>ООО «БНК».</p>
                            <p><strong>Конечный заказчик: </strong>ООО «Новая Энергия».</p>
                            <p><strong>Дата: </strong>сентябрь - октябрь 2025 г.</p>
                            <p><strong>Срок выполнения: </strong>60 рабочих дней.</p>
                            <h3 className={style.results}>Результаты работ:</h3>
                            <ul>
                                <li>Установлено 12 комплектных трансформаторных подстанций типа 2КТП(Н) и 3 комплектные трансформаторные подстанции типа КТП(Н).</li>
                                <li>Обеспечена выдача мощности СЭС Зодиак в сеть 10 кВ.</li>
                                <li>Создана надёжная трансформаторная инфраструктура из 15 подстанций общей мощностью 85 МВА.</li>
                                <li>Выполнены все пусконаладочные работы.</li>
                            </ul>
                        </div>
                        <div className={style.solution}>
                            <h3>Решения для проекта:</h3>
                            <ul>
                                <li>Установлено 27 трансформаторов ТМГ-СЭЩ-3150/10,5/0,8 кВ общей мощностью 85 МВА.</li>
                                <li>Смонтировано 15 блочно-модульных зданий (БМЗ) КТП с площадками обслуживания.</li>
                                <li>Проложены кабельные линии 10 кВ от трансформаторов до ячеек РУ 10 кВ.</li>
                                <li>Смонтированы системы заземления оборудования 2КТП(Н) и КТП(Н).</li>
                                <li>Проведены пусконаладочные работы каждой КТП, включая наладку ОПС и шкафов связи, подготовлены и переданы исполнительная документация и технические отчёты ПНР.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <HireUs />
            <Portfolio />
            <div style={{height: '2rem'}}></div>
            <ContactForm />
        </div>
    )
}